import type { SxProps, Theme } from '@mui/material'

/** @type {Styles} */
export const styles = {
  searchIcon: {
    marginRight: { md: 1.5 },
    fontSize: 24,
    color: 'primary.main',
  },
  thickDivider: {
    backgroundColor: 'gray.3',
    height: 8,
    border: 0,
    borderTop: (theme: Theme) => `1px solid ${theme.palette.gray[8]}`,
  },
  clearSearchIcon: {
    marginRight: 1,
    backgroundColor: 'transparent',
    '.MuiSvgIcon-root': {
      color: 'gray.40',
    },
    ':hover': {
      border: 'none',
      backgroundColor: 'transparent',
    },
    ':focus': {
      border: 'none',
      backgroundColor: 'transparent',
    },
  },
  formTag: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  disabled: {
    '.Mui-disabled': {
      backgroundColor: 'gray.3',
    },
  },
  disabledSearchIcon: {
    color: 'gray.40',
  },
  searchIconButton: {
    marginRight: 1.5,
    backgroundColor: 'transparent',
    minWidth: 'auto',
    padding: 0,
    '.MuiSvgIcon-root': {
      fontSize: 24,
      color: 'primary.main',
    },
    ':hover': {
      border: 'none',
      backgroundColor: 'transparent',
      '.MuiSvgIcon-root': {
        color: 'primary.dark',
      },
    },
    ':focus': {
      border: 'none',
      backgroundColor: 'transparent',
    },
    '&.Mui-disabled': {
      '.MuiSvgIcon-root': {
        color: 'gray.40',
      },
    },
  },
}

interface HandleStylesWithPropsArgs {
  sx?: SxProps<Theme>
  isDisabled?: boolean
  hasToolbarWithBorder?: boolean
  showSearchFieldBorder?: boolean
}

export const handleStylesWithProps = ({
  sx,
  isDisabled,
  hasToolbarWithBorder,
  showSearchFieldBorder,
}: HandleStylesWithPropsArgs) => {
  const baseSx: SxProps<Theme>[] = Array.isArray(sx) ? [...sx] : sx ? [sx] : []

  return {
    container: [
      ...baseSx,
      isDisabled && styles.disabled,
      {
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderTopLeftRadius: hasToolbarWithBorder ? 0 : 0.5,
            borderTopRightRadius: hasToolbarWithBorder ? 0 : 0.5,
            ...(showSearchFieldBorder
              ? {
                  borderWidth: 1,
                  borderStyle: 'solid',
                  borderColor: 'gray.12',
                }
              : { border: 'none' }),
          },
        },
      },
    ].filter(Boolean) as SxProps<Theme>,
  }
}
